const ADMIN_TOKEN_KEY = "admin-token"

export const getAdminToken = (): string | null =>
  sessionStorage.getItem(ADMIN_TOKEN_KEY) ?? localStorage.getItem(ADMIN_TOKEN_KEY)

export const setAdminToken = (token: string, remember: boolean): void => {
  if (remember) {
    localStorage.setItem(ADMIN_TOKEN_KEY, token)
  } else {
    sessionStorage.setItem(ADMIN_TOKEN_KEY, token)
  }
}

export const clearAdminAuth = (): void => {
  localStorage.removeItem(ADMIN_TOKEN_KEY)
  sessionStorage.removeItem(ADMIN_TOKEN_KEY)
}

export const isAdminTokenValid = (): boolean => {
  const token = getAdminToken()
  if (!token) return false
  try {
    const parts = token.split(".")
    if (parts.length !== 3) return false
    const payload = JSON.parse(atob(parts[1]))
    if (payload.exp) {
      return payload.exp > Math.floor(Date.now() / 1000) + 60
    }
    return true
  } catch {
    return false
  }
}
